import React from "react";

export default function Legacy() {
  return (
    <section
      id="legacy"
      data-testid="legacy-section"
      className="relative py-28 md:py-36 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Text */}
          <div className="lg:col-span-6 order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#d4af37]" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#d4af37] font-bold">
                The Legacy
              </span>
            </div>
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9]">
              Over Two Decades <br /> <span className="text-[#d4af37]">On The Mats.</span>
            </h2>
            <div className="mt-8 space-y-5 text-white/75 text-base md:text-lg leading-relaxed max-w-xl">
              <p>
                Full Circle MMA was built by Russell Thompson — a pioneer on the
                Illawarra mat back when most Australians hadn't yet heard of
                mixed martial arts. He trained, fought and coached through the
                years the sport was still finding its name, long before UFC
                nights filled pubs across the country.
              </p>
              <p>
                We don't chase trends. We chase craft — the jab that lands a
                thousand times, the guard pass that breaks a will, the round
                that changes a life.
              </p>
              <p>
                Whether you're stepping on the mat for the first time or prepping
                for a title shot, you train the same way here: honestly.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 border-t border-white/10">
              <div className="py-6 pr-6 border-r border-white/10">
                <div className="font-heading text-4xl md:text-5xl text-[#d4af37]">20+</div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/60 mt-2">Years</div>
              </div>
              <div className="py-6 pl-6">
                <div className="font-heading text-4xl md:text-5xl text-[#d4af37]">2</div>
                <div className="text-xs uppercase tracking-[0.2em] text-white/60 mt-2">Pillars</div>
              </div>
            </div>
          </div>

          {/* Image collage */}
          <div className="lg:col-span-6 order-1 lg:order-2 relative">
            <div className="relative aspect-[4/5] w-full max-w-md ml-auto">
              <img
                src="https://images.pexels.com/photos/5424528/pexels-photo-5424528.jpeg"
                alt="Training session at Full Circle MMA"
                className="w-full h-full object-cover grayscale contrast-125"
              />
              <div className="absolute top-6 -right-4 hidden md:block border-l-4 border-[#d4af37] pl-4">
                <div className="text-[10px] uppercase tracking-[0.3em] text-white/50">Illawarra's</div>
                <div className="font-heading text-white text-xl uppercase">Home of MMA</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
